import * as React from 'react';
import { IconDelivery, IconPlate, IconToGo, IconWineGlass } from '@tock/icons';
import { consumer } from '@tock/coretypes';
import { deliveryServiceProviderDisplayName } from '@tock/shared/utils/offerings';
import { getSizeContent, getTypeContent } from 'utils/experience';
import OfferingDetailsMetadataItem from 'components/business/offering/OfferingDetailsMetadataItem';

interface Props {
  offering: consumer.Offering;
  businessType?: string;
}

const OfferingDetailsType: React.FunctionComponent<Props> = ({ offering, businessType }) => {
  let icon;
  switch (offering.type) {
    case 'ORDER_DELIVERY':
      icon = IconDelivery;
      break;

    case 'ORDER_PICKUP':
      icon = IconToGo;
      break;

    default:
      icon = businessType === 'Winery' ? IconWineGlass : IconPlate;
      break;
  }

  let typeContent = getTypeContent(
    offering.type,
    offering.purchaseSize,
    offering.descriptiveVariety,
    offering.singleUnitQuantity
  );
  const sizeContent = getSizeContent(offering.type, offering.purchaseSize);

  if (offering.type === 'ORDER_DELIVERY' && offering.deliveryServiceProvider !== 'INTERNAL') {
    typeContent = (
      <>{`${deliveryServiceProviderDisplayName(offering.deliveryServiceProvider)} delivery`}</>
    );
  }

  return (
    <OfferingDetailsMetadataItem icon={icon} data-testid="offering-details">
      {typeContent}
      {sizeContent}
    </OfferingDetailsMetadataItem>
  );
};

export default OfferingDetailsType;
